// Zentrale Kontaktdaten - SINGLE SOURCE OF TRUTH
// Bei Änderungen NUR diese Datei bearbeiten!

export const CONTACT = {
  // Telefon
  phone: "0461 313 68 98",
  phoneFormatted: "0461 / 313 68 98",
  phoneTel: "tel:+494613136898", // für href links
  phoneRaw: "+494613136898",
  
  // WhatsApp
  whatsapp: "01575 944 26 52",
  whatsappFormatted: "01575 / 944 26 52",
  whatsappLink: "https://wa.me/4915759442652",
  whatsappRaw: "+4915759442652",
  
  // E-Mail
  email: "praxis@ergotherapie-flensburg.de",
  emailLink: "mailto:praxis@ergotherapie-flensburg.de",
  
  // Adresse
  address: {
    street: "Engelsbyer Straße 2",
    postalCode: "24943",
    city: "Flensburg",
    region: "Schleswig-Holstein",
    country: "DE",
    full: "Engelsbyer Straße 2, 24943 Flensburg",
  },
  
  // Google Maps
  mapsLink: "https://maps.app.goo.gl/aCRjFAG8FCLaCwHf8",
  coordinates: {
    lat: 54.7915177299845,
    lng: 9.466005380023486,
  },
  
  // Social Media
  instagram: "https://www.instagram.com/ergotherapie_engelsby",
  instagramHandle: "ergotherapie_engelsby",
  
  // Öffnungszeiten
  openingHours: {
    weekdays: "Mo – Fr: 7:30 – 19:00 Uhr",
    weekend: "Sa & So: geschlossen",
    opens: "07:30",
    closes: "19:00",
  },
  
  // Website
  siteUrl: "https://ergotherapie-flensburg.de",
  siteName: "Praxis für Ergotherapie und Handtherapie",
}

export default CONTACT

